import type { App } from '@grafikr/components';

import Cart from 'utils/cart';

let lastCartEventAt = 0;

export const isRecentCartEvent = (withinMs = 1000) =>
  lastCartEventAt > 0 && Date.now() - lastCartEventAt < withinMs;

export default ({ context }: App) => {
  const getCart = () => {
    lastCartEventAt = Date.now();

    Cart.get({
      success: (body) => {
        theme.cart = body;

        context.dispatchEvent('cart:fetched', body);
      },
    });
  };

  document.addEventListener('cart:added', getCart);
  document.addEventListener('cart:updated', getCart);
};
